// Core
import React from "react";

// Styles
import "./styles.scss";

const Stepper = ({ steps }) => {
  function formatTimeToAmPm(dateString) {
    const date = new Date(dateString);
    return date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
  }

  return (
    <div className="stepper-container">
      {steps.map((step, index) => (
        <div className="step-wrapper" key={index}>
          {/* Date and Time */}
          <div className="step-date-time">
            <div className="step-date">
              {step.value
                ? new Date(step.value).toLocaleDateString("en-GB")
                : " "}
            </div>
            <div className="step-time">
              {step.value ? formatTimeToAmPm(step.value) : " "}
            </div>
          </div>

          {/* Indicator */}
          <div className="status-indicator">
            {index > 0 && <div className="indicator-line above"></div>}
            <div
              className={`indicator-circle ${
                step.value ? "completed" : "pending"
              }`}
            ></div>
            {index < steps.length - 1 && <div className="indicator-line"></div>}
          </div>

          {/* Description */}
          <div
            className={`step-content ${step.value ? "completed" : "pending"}`}
          >
            <div className="step-description">{step.name}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Stepper;
